declare const TAL: { config: IAppConfig };

export const config: IAppConfig =
  typeof TAL === "undefined" ? ({} as IAppConfig) : TAL.config;

export const appName = config?.appName || "profile-rx";
